import { ActionTree } from 'vuex'

import { NoticeState, RootState } from '@/types/store'
import { INotice, NoticeParams } from '@/types/notice'

import {
  createNotice,
  deleteNotice,
  getNotices,
  updateNotice,
} from '@/api/notices'
import { UserRole } from '@/types/user'

export const actions: ActionTree<NoticeState, RootState> = {
  async createNotice({ commit }, notice: INotice): Promise<void> {
    const created = await createNotice(notice)
    commit('createNotice', created)
  },
  async getNotices({ commit }, params: NoticeParams): Promise<void> {
    commit('setIsNoticesLoading', true)
    const notices = await getNotices(params)
    commit('setIsNoticesLoading', false)
    commit('noticesLoaded', notices)
  },
  async getNotice({ commit }, notice: INotice): Promise<void> {
    commit('setNotice', notice)
  },
  async setNewNotice({ commit }): Promise<void> {
    const notice: INotice = {
      id: -1,
      title: '',
      content: '',
      distributeFor: UserRole.ANY,
      createdById: -1,
      isValid: true,
      createdAt: new Date(),
      updatedAt: new Date(),
      deletedAt: null,
    }
    commit('setNotice', notice)
  },
  async updateNotice({ commit }, notice: INotice): Promise<string> {
    // return error
    try {
      notice = await updateNotice(notice)
      commit('updateNotice', notice)
      return ''
    } catch (error) {
      return error
    }
  },
  async deleteNotice({ commit }, id: number): Promise<void> {
    await deleteNotice(id)
    commit('deleteNotice', id)
  },
}
